export const PASSWORD_REQUIREMENTS = [
  { id: "length", label: "Minst 8 tecken", test: (password) => password.length >= 8 },
  { id: "uppercase", label: "Minst en stor bokstav", test: (password) => /[A-ZÅÄÖ]/.test(password) },
  { id: "number", label: "Minst en siffra", test: (password) => /\d/.test(password) },
];

export function getPasswordRequirementState(password = "") {
  const value = String(password || "");
  return PASSWORD_REQUIREMENTS.map((requirement) => ({
    ...requirement,
    valid: requirement.test(value),
  }));
}

export function isPasswordValid(password = "") {
  return getPasswordRequirementState(password).every((requirement) => requirement.valid);
}

export const PASSWORD_POLICY_MESSAGE = "Lösenordet måste vara minst 8 tecken och innehålla en stor bokstav och en siffra.";
